'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Right = require('./Right');

var _Right2 = _interopRequireDefault(_Right);

var _Left = require('./Left');

var _Left2 = _interopRequireDefault(_Left);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { Left: _Left2.default, Right: _Right2.default };


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Angle/index.js
// module id = 1089
// module chunks = 1